import React from 'react';
import { useParams } from 'react-router-dom';
import sintv1 from './images/sintv1.webp';
import sintv2 from './images/sintv2.webp';
import sintv3 from './images/sintv3.webp';
import sintv4 from './images/sintv4.webp';
import bould1 from './images/bould1.webp';
import bould2 from './images/bould2.webp';
import bould3 from './images/bould3.webp';
import bould4 from './images/bould4.webp';
import ae1 from './images/ae1.webp';
import ae2 from './images/ae2.webp';
import ae3 from './images/ae3.webp';
import ch4 from './images/ch4.webp';
import ch3 from './images/ch3.webp';
import ch2 from './images/ch2.webp';
import ch1 from './images/ch1.webp';
import dmp1 from './images/dmp1.webp';
import dmp2 from './images/dmp2.webp';
import dmp3 from './images/dmp3.webp';
import dmp4 from './images/dmp4.webp';
const ProjectDetail = () => {
  const { id } = useParams();
  // Fetch the project details using the id (You can implement this part)

  // Updated dummy project data with an array of images
  const dummyProjects = [
    {
      id: 4,
      title: "SINTV",
      description: "SinTV is an innovative digital platform that offers comprehensive access to a variety of multimedia content, including movies, live television, radio and music, all accessible from a single application. This service is based on Internet technology without requiring complex physical installations, taking advantage of SINT's fiber optic network to ensure high quality transmission. The user interface design focused on optimizing the user experience, ensuring intuitive and fast navigation.",
      year: "2021",
      category: "UI/UX Design",
      tags: "Digital Streaming, User Interface",
      images: [
        sintv2,
        sintv1,
        sintv3,
        sintv4
      ]
    },    
    {
      id: 3,
      title: "BOULD",
      description: "Bould revolutionizes the online shopping experience through cutting-edge technology, offering a personalized and immersive fashion shopping experience. Utilizing advanced 3D avatar technology, customers can try on clothes virtually from anywhere, ensuring a true-to-size fit and reducing the need for returns. The platform provides a seamless interface where users can receive personalized outfit recommendations from a virtual stylist, making shopping convenient and tailored to individual styles. Bould aims to redefine e-commerce by combining the convenience of online shopping with the personal touch of in-store experiences.",
      year: "2022",
      category: "3D Animation & Virtual Reality, UI/UX Design",
      tags: "Online Shopping, Virtual Try-On, 3D Technology",
      link: "https://bouldhq.com/",
      linkname: "Visit BouldHQ",
      images: [
        bould3,
        bould4,
        bould1,
        bould2
      ]
    },    
    {
      id: 2,
      title: "Acoma Energy Website Development",
      description: "Our project involved the redevelopment of the Acoma Energy website, formerly known as AED Group. Founded in 2006, Acoma Energy transitioned from a land services business to focus on developing leasehold prospects, acquiring minerals, and participating in non-operational working interests across the lower 48 states. The website we developed presents a clear and efficient platform for the company to communicate its refined focus, showcase its services, and facilitate engagement with potential clients. The site includes detailed sections about the company’s history, current projects, and a contact interface to encourage discussions on prospective deals.",
      year: "2023",
      category: "Web Development",
      tags: "Energy Sector, Business Transition, Client Engagement",
      link: "https://acomaenergy.com/",
      linkname: "Visit Acoma Energy",
      images: [
        ae1,
        ae2,
        ae3,
      ]
    },
    // Keep the existing 'Ersatz' project here
    {
      id: 1,
      title: "CleanHits Interactive Website",
      description: "For CleanHits, we developed a comprehensive interactive website that integrates state-of-the-art 3D technology to enhance user engagement. Users can interact with detailed 3D models of CleanHits products in a virtual environment, allowing them to explore features and functionalities before making a purchase. This immersive experience is designed to not only inform but also entertain, providing a unique shopping experience that leverages the latest in web and 3D technology to simulate real-life product interaction.",
      year: "2023",
      category: "Web Development and 3D Modeling",
      tags: "3D Visualization, Interactive Website, Product Engagement, Advanced Web Technology",
      link: "https://cleanhits-ce4ff.web.app",
      linkname: "Visit CleanHits",
      
      images: [
        ch1,
        ch2,
        ch3,
        ch4
      ]
    },    
    {
      id: 0,
      title: "D' Manuel Productions Brand Style Guide",
      description: "We were tasked with the redesign of the D' Manuel Productions logo and the creation of a new brand style guide to support their expanding business. D' Manuel Productions, a concert management and organization company based in Peru, is preparing to take their operations worldwide. Our redesign focused on modernizing their existing logo to better reflect their dynamic and expansive approach to managing live events. The comprehensive brand style guide we developed ensures consistency in branding across all future communications as they expand globally, enhancing their professional image in the international music and entertainment industry.",
      year: "2023",
      category: "Graphic Design, Concept Work",
      tags: " Brand Development, Entertainment Industry, Global Expansion",
      images: [
        dmp1,
        dmp2,
        dmp4,
        dmp3
      ]
    }
    
  ];
    // Find the project by id
    const project = dummyProjects.find(p => p.id.toString() === id);

    // If no project is found, you can return null or some error message
    if (!project) {
      return <div>Project not found</div>;
    }

  // Style objects
  const detailStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '5rem 1rem',
  };

  const headerStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '2rem',
    textAlign: 'center',
  };

  const titleStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
  };

  const metaStyle = {
    fontSize: '1rem',
    fontStyle: 'italic',
  };

  const imagesContainerStyle = {
    gridTemplateColumns: 'repeat(auto-fit, minmax(550px, 1fr))',
    gap: '0.5rem',
    marginBottom: '5rem',
  };

  const imageStyle = {
    width: '100%',
    height: 'auto',
    marginBottom: '0.5rem',
    borderRadius: '20px', // Curved corners
  };
  const linkStyle = {
    fontWeight: 'bold',
    color: 'inherit', // Use the same color as the surrounding text or specify a custom color
    textDecoration: 'none' // Removes underline from the link
  }

  return (
    <div style={detailStyle}>
    <div style={headerStyle}>
      <h2 style={titleStyle}>{project.title}</h2>
      <p>{project.description}</p>
      <span style={metaStyle}>{`${project.year} - ${project.category} - ${project.tags}`}</span>
      <a style={linkStyle} href={project.link}>{project.linkname}</a>
    </div>
    <div style={imagesContainerStyle}>
      {project.images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`${project.title} ${index + 1}`}
          style={imageStyle}
        />
      ))}
    </div>
  </div>
  );
};

export default ProjectDetail;